import React from 'react';
import { contactInfo } from '../../data/contact';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import '../../styles/components/Contact.css';
import '../../styles/animations.css';

const Contact = () => {
  const { elementRef, isVisible } = useScrollAnimation();

  return (
    <div className="section">
      <div
        ref={elementRef}
        className={`contactSection animate-section ${isVisible ? 'visible' : ''}`}
      >
        <h2 className={`animate-element delay-1 ${isVisible ? 'visible' : ''}`}>
          Contact
        </h2>
        <ul>
          <li className={`animate-list-item delay-2 ${isVisible ? 'visible' : ''}`}>
            <span className="contactLabel">LinkedIn</span>
            <span>
              <a href={contactInfo.linkedin} target="_blank" rel="noopener noreferrer">
                {contactInfo.linkedinText}
              </a>
            </span>
          </li>
          <li className={`animate-list-item delay-3 ${isVisible ? 'visible' : ''}`}>
            <span className="contactLabel">Email</span>
            <span>
              <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Contact; 